import { detectLanguage, getLocalizedLabels } from '../../../utils/language';
import { getLocationLabels } from '../../../utils/translations/locationLabels';

export default async function init() {
  const locations = document.querySelectorAll('[data-js-module="location"]');

  const initLocation = async () => {
    const { default: LocationApp } = await import('./location.jsx');

    locations.forEach((element) => {
      try {
        const data = JSON.parse(element.dataset.jsModuleConfig);
        const language = detectLanguage();

        // Lokalisierte Daten basierend auf der erkannten Sprache
        const localizedData = {
          ...data,
          language, // Immer die Sprache weitergeben
          headline: data.headline || (language === 'en' ? 'Where to find us' : 'Wo Sie uns finden'),
          maps: {
            ...data.maps,
            us: { ...data.maps?.us, label: 'USA' },
            europe: { ...data.maps?.europe, label: language === 'en' ? 'Europe' : 'Europa' }
          },
          // Labels aus zentraler Quelle verwenden (importierte Funktion)
          labels: {
            ...getLocationLabels(language),
            ...getLocalizedLabels(data, language)
          }
        };

        new LocationApp(element, { data: localizedData });
      } catch (error) {
        console.error('Error initializing Location component:', error);
      }
    });
  };

  if (locations.length) initLocation();
}

init();
